import type { RootState } from 'modules';

export const selectUI = (state: RootState) => state.ui;

export const uiSelector = {
  isSpinnerShow: (state: RootState) => selectUI(state).spinnerRequestCount > 0,
};
